import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { pageMotion } from "../motion/pageMotion";
import {
  CircleMarker,
  MapContainer,
  TileLayer,
  useMap,
  Popup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import styled from "styled-components";

const MapFrame = styled.div`
  width: 100%;
  height: 280px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid var(--border-default);
  background: var(--surface-2, #e8eee9);
  position: relative;

  .leaflet-container {
    width: 100%;
    height: 100%;
    font-family: inherit;
  }
`;

function Recenter({ lat, lon }) {
  const map = useMap();
  useEffect(() => {
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return;
    map.flyTo([lat, lon], 14, { animate: true, duration: 0.95 });
  }, [lat, lon, map]);
  return null;
}

/**
 * Mapa embutido (Leaflet/OSM) com o ponto do alerta — mesmo padrão do hub de projeto.
 */
export default function AlertLocationMap({ lat, lon, label }) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;

  return (
    <motion.div
      initial={pageMotion.initial}
      animate={pageMotion.animate}
      transition={{ ...pageMotion.transition, delay: 0.08 }}
      style={{ width: "100%" }}
    >
    <MapFrame>
      <MapContainer
        center={[lat, lon]}
        zoom={7}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Recenter lat={lat} lon={lon} />
        <CircleMarker
          center={[lat, lon]}
          radius={10}
          pathOptions={{
            color: "var(--accent, #00a86b)",
            fillColor: "var(--accent, #00a86b)",
            fillOpacity: 0.85,
            weight: 2,
          }}
        >
          {label ? <Popup>{label}</Popup> : null}
        </CircleMarker>
      </MapContainer>
    </MapFrame>
    </motion.div>
  );
}
